import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { FaroErrorBoundary } from '@cortex/faro/react';
import { config } from './config';
import { routeTree } from './routeTree.gen';
import { ToastProvider } from './components/ui/Toast';

// TanStack Query クライアント
/** @graph-connects none */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: config.query.staleTime,
      gcTime: config.query.gcTime,
      retry: config.query.retry,
      refetchOnWindowFocus: config.query.refetchOnWindowFocus,
    },
  },
});

// TanStack Router
/** @graph-connects none */
const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

// 型安全なルーター用の型宣言
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * @graph-node {Function}
 * @graph-stack cortex-admin
 * @graph-domain Engineering
 * @graph-business アプリケーションルート。TanStack Query Provider・Router・Toast Provider・ErrorBoundaryを統合
 * @graph-connects config [calls] アプリケーション設定定数を参照
 * @graph-connects ToastProvider [calls] Toast通知プロバイダー呼び出し
 */
export function App() {
  return (
    <FaroErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryClientProvider>
    </FaroErrorBoundary>
  );
}
